import { JSX } from 'react';
import { Platform } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../components/core';
import { PageFooter } from '../../components/page';
import { usePushNotifications } from '../../plugins/pushNotifications/usePushNotifications';
import { getRoute } from '../../routes';
import { getStylesheet } from '../../styles';
import { useTitle } from '../../utils/useTitle';
import { TermsRequired } from '../blocked/components/TermsRequired';

export function OnboardingTermsPage(): JSX.Element {
  useTitle(['Accept Terms', 'Welcome']);

  const navigate = useNavigate();
  const { registerForPushNotifications } = usePushNotifications();

  const onSaved = async (): Promise<void> => {
    if (Platform.OS !== 'web') {
      await registerForPushNotifications();
    }
    navigate(getRoute('onboardingPhoneNumber', {}));
  };

  return (
    <Layout.Flex {...styles.page} testID="onboarding-terms-page">
      <TermsRequired onSaved={onSaved} />

      <PageFooter />
    </Layout.Flex>
  );
}

const styles = getStylesheet({
  page: {
    height: '100%',
    marginTop: 16,
    position: 'relative',
  },

  stack: {
    alignItems: 'center',
    display: 'flex',
  },
});
